import axios from 'axios';

export function sendEsign(method, data) {
  const token = localStorage.getItem('SessionToken');
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/send-esign/${method}/`,
    method: 'post',
    headers: { Authorization: `Token ${token}` },
    data,
  });
}
